export default function StickyNav() {
    let lastScrollTop = 0;
    const navbar = document.getElementById('mainHeader');
    const topPosition = document.body.classList.contains('logged-in') ? '32px' : '0px';
    let navbarHidden = false;
  
    function onScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  
      if (currentScroll > lastScrollTop && currentScroll > window.innerHeight / 2) {
        // Scrolling down
        if (!navbarHidden) {
          navbar.style.top = '-100%'; // Hide the navbar
          navbar.style.position = 'fixed';
          navbarHidden = true;
        }
      } else {
        // Scrolling up or less than one viewport height
        if (navbarHidden || currentScroll <= window.innerHeight) {
          navbar.style.top = topPosition; // Show the navbar
          navbar.style.position = 'fixed';
          navbarHidden = false;
        }
      }
  
      lastScrollTop = currentScroll;
    }
  
    window.addEventListener('scroll', onScroll);
  }
  